export enum VolumeType {
    Seismic2D = 0,
    Seismics3D = 1
}